<template>
  <div class="flex items-center">
    <h3 class="text-2xl font-semibold leading-none text-[#e53935] mr-1"><strong v-if="percentage">{{ percentage }}</strong></h3>
    <div class="w-full">
      <p class="mb-1 leading-none"><strong class="text-[#e53935]">%</strong> • {{ current }} из {{ total }}</p>
      <div class="flex overflow-hidden rounded-[5px] border border-black/[0.125] bg-gray-200" style="height: 10px;">
        <div class="bg-[#0E245A]" role="progressbar" :style="'width:' + percentage + '%'" :aria-valuenow="percentage" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      total: Number,
      current: Number
    },
    data () {
      return {
        isActive: false
      }
    },
    computed: {
      percentage () {
        return Number((this.current * 100 / this.total).toFixed(1))
      }
    },
    methods: {
      toggleFocus () {
        this.isActive = !this.isActive
      }
    }
  }
</script>